/*
  NAAMANE wishlist: eigen code, geen app.
  Bewaart producthandles in de browser (localStorage) en werkt zonder account.
  Elementen:
  - <nm-wishlist-button data-handle="..."><button type="button">...</button></nm-wishlist-button>
  - <nm-wishlist-count></nm-wishlist-count>
  - <nm-wishlist-grid data-root="/" data-locale="nl-NL" data-currency="EUR"></nm-wishlist-grid>
*/
const KEY = 'nm-wishlist';
const MAX = 60;

function read() {
  try {
    const list = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(list) ? list.filter((h) => typeof h === 'string') : [];
  } catch (e) {
    return [];
  }
}

function write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch (e) {
    /* privévenster of opslag geblokkeerd: lijst blijft alleen voor deze pagina */
  }
  document.dispatchEvent(new CustomEvent('nm:wishlist', { detail: list }));
}

function toggle(handle) {
  const list = read();
  const i = list.indexOf(handle);
  if (i > -1) list.splice(i, 1);
  else list.unshift(handle);
  write(list);
  return i === -1;
}

class NmWishlistButton extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    this.handle = this.dataset.handle;
    this.button = this.querySelector('button');
    if (!this.button || !this.handle) return;
    this._onClick = (event) => {
      event.preventDefault();
      event.stopPropagation();
      const added = toggle(this.handle);
      this.classList.remove('nm-wl--pop');
      if (added) {
        void this.offsetWidth;
        this.classList.add('nm-wl--pop');
        /* Meten: eigen event voor GA4, Meta en TikTok via Shopify Customer Events */
        try { window.Shopify?.analytics?.publish?.('naamane_wishlist_add', { handle: this.handle }); } catch (e) { /* niet kritisch */ }
      }
    };
    this._sync = () => this.update();
    this.button.addEventListener('click', this._onClick);
    document.addEventListener('nm:wishlist', this._sync);
    window.addEventListener('storage', this._sync);
    this.update();
  }

  disconnectedCallback() {
    this._ready = false;
    this.button?.removeEventListener('click', this._onClick);
    document.removeEventListener('nm:wishlist', this._sync);
    window.removeEventListener('storage', this._sync);
  }

  update() {
    const on = read().includes(this.handle);
    this.toggleAttribute('active', on);
    this.button.setAttribute('aria-pressed', String(on));
    this.button.setAttribute('aria-label', on ? 'Verwijder uit je wishlist' : 'Bewaar in je wishlist');
  }
}

class NmWishlistCount extends HTMLElement {
  connectedCallback() {
    this._sync = () => {
      const n = read().length;
      this.textContent = n > 0 ? String(n) : '';
      this.hidden = n === 0;
    };
    document.addEventListener('nm:wishlist', this._sync);
    window.addEventListener('storage', this._sync);
    this._sync();
  }

  disconnectedCallback() {
    document.removeEventListener('nm:wishlist', this._sync);
    window.removeEventListener('storage', this._sync);
  }
}

class NmWishlistGrid extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    this.root = this.dataset.root || '/';
    if (!this.root.endsWith('/')) this.root += '/';
    this.money = new Intl.NumberFormat(this.dataset.locale || 'nl-NL', {
      style: 'currency',
      currency: this.dataset.currency || 'EUR',
    });
    this.list = this.querySelector('[data-list]');
    this.empty = this.querySelector('[data-empty]');
    this._sync = () => this.render();
    document.addEventListener('nm:wishlist', this._sync);
    this.render();
  }

  disconnectedCallback() {
    this._ready = false;
    document.removeEventListener('nm:wishlist', this._sync);
  }

  async render() {
    const handles = read();
    this.empty.hidden = handles.length > 0;
    if (!handles.length) {
      this.list.replaceChildren();
      return;
    }
    const results = await Promise.all(
      handles.map((h) =>
        fetch(`${this.root}products/${encodeURIComponent(h)}.js`)
          .then((r) => (r.ok ? r.json() : null))
          .catch(() => null)
      )
    );
    const products = results.filter(Boolean);
    const gone = handles.filter((h, i) => !results[i]);
    if (gone.length) write(handles.filter((h) => !gone.includes(h)));
    this.list.replaceChildren(...products.map((p) => this.card(p)));
    this.empty.hidden = products.length > 0;
  }

  card(p) {
    const url = `${this.root}products/${p.handle}`;
    const img = p.featured_image ? `${p.featured_image}${p.featured_image.includes('?') ? '&' : '?'}width=600` : '';
    const sale = p.compare_at_price && p.compare_at_price > p.price;
    const el = document.createElement('li');
    el.className = 'nm-wlg__item';
    el.innerHTML = `
      <a class="nm-wlg__media" href="${url}">${img ? `<img src="${img}" alt="" loading="lazy" width="600" height="800">` : ''}</a>
      <nm-wishlist-button class="nm-wl nm-wl--card" data-handle="${p.handle}">
        <button type="button" class="nm-wl__btn">${HEART}</button>
      </nm-wishlist-button>
      <a class="nm-wlg__title" href="${url}"></a>
      <p class="nm-wlg__price">${sale ? `<s>${this.money.format(p.compare_at_price / 100)}</s> ` : ''}${this.money.format(p.price / 100)}</p>
      ${p.available ? '' : '<p class="nm-wlg__soldout">Uitverkocht</p>'}`;
    el.querySelector('.nm-wlg__title').textContent = p.title;
    return el;
  }
}

const HEART =
  '<svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M12 20.5s-7.5-4.6-9.2-9.4C1.6 7.6 3.9 4.5 7.2 4.5c2 0 3.5 1.1 4.8 2.9 1.3-1.8 2.8-2.9 4.8-2.9 3.3 0 5.6 3.1 4.4 6.6-1.7 4.8-9.2 9.4-9.2 9.4Z"/></svg>';

if (!customElements.get('nm-wishlist-button')) customElements.define('nm-wishlist-button', NmWishlistButton);
if (!customElements.get('nm-wishlist-count')) customElements.define('nm-wishlist-count', NmWishlistCount);
if (!customElements.get('nm-wishlist-grid')) customElements.define('nm-wishlist-grid', NmWishlistGrid);
